import type { ExternalSourceDirectory, ExternalSourceItem } from 'models/underlying';
import config from 'utils/config';

export type ExternalSourceJsonSuffix = 'history' | 'current';

/** Shared by the server resource hint and the client query so their request URLs stay byte-identical. */
export const getExternalSourceJsonUrl = (
    directory: ExternalSourceDirectory,
    item: ExternalSourceItem,
    suffix: ExternalSourceJsonSuffix,
): string => `${config.kalshiPublicDocsCloudfrontUrl}/external/${directory}/${item.toLowerCase()}_${suffix}.json`;

type DocumentHistoryPreloads = Record<string, Promise<Response>>;

declare global {
    interface Window {
        __kalshiDocumentHistoryPreloads?: DocumentHistoryPreloads;
    }
}

/** Takes ownership of the parser-started response exactly once; later polls always use the network path. */
export const consumeDocumentHistoryPreload = (url: string): Promise<Response> | undefined => {
    if (typeof window === 'undefined') return undefined;

    const preloads = window.__kalshiDocumentHistoryPreloads;
    const response = preloads?.[url];
    if (response && preloads) delete preloads[url];
    return response;
};
